import React from 'react'
import { connect } from 'react-redux'
import {
    ajaxFeedbackStatusFilter,
    setCustomTimeframe,
    setFilterTimeframe, setLoading,
    updateModalContent
} from './redux/FeedbackRedux'
import Loading from './Loading'

class DashboardActionBar extends React.Component {
    constructor() {
        super();
        this.state = {
            send_email: window.user_email ?? "",
        };
    }

    handleClick(event) {
        let timeframe = event.target.id;
        console.log(timeframe);
        var ids = this.props.business_id ?? null;
        if (this.props.businesses) {
            ids = [];
            for (var i in this.props.businesses) {
                ids.push(this.props.businesses[i].business_id);
            }
        }
        window.localStorage.setItem("timeframe", timeframe);
        this.props.dispatch(setFilterTimeframe(timeframe))

        if (this.props.doDispatch) {
            this.props.dispatch(
                ajaxFeedbackStatusFilter(
                    this.props.state,
                    null,
                    timeframe,
                    null,
                    null,
                    this.props.excludeStatistics
                )
            );
        }

        // notify the parent timeframe changed
        // currently used in All Business Dashboard
        if (this.props.onTimeframeChange) {
            this.props.onTimeframeChange(timeframe);
        }
    }

    handleDownloadClick(event) {
        var ids = [];
        for (var i in this.props.businesses) {
            ids.push(this.props.businesses[i].business_id);
        }

        var data = {
            user_id: this.props.current_user,
            business_ids: ids,
            timeframe: this.props.timeframe,
            status: this.props.status,
            timezone: this.props.businesses[0].call_at_timezone,
            dept_ids: this.props.department_ids,
            region: this.props.region ? this.props.region.id : null,
            tfstart: this.props.timeframe_prev,
            tfend: this.props.timeframe_next,
        };
        var url = "/dashboard/report/download-pdf?";
        for (var d in data) {
            url += d;
            url += "=";
            url += data[d];
            url += "&";
        }

        alert(__("PDF File is being generated. It will be downloaded automatically once it is done processing."));
        document.location = url;
    }

    handleExportButtonClick() {
        const modal_id = "download_XLS";
        const modal_title = __('Download XLS Export');
        const modal_body = "exportXls";
        const button_1_class = "outline-primary";
        const button_1_id = "cancel";
        const button_1_text = __("Cancel");
        const button_2_class = "primary";
        const button_2_id = "export_xls_send_btn";
        const button_2_text = __("Send Report");
        this.props.dispatch(updateModalContent({ modal_id: modal_id, modal_title: modal_title, modal_body: modal_body, button_1_class: button_1_class, button_1_id: button_1_id, button_1_text: button_1_text, button_2_class: button_2_class, button_2_id: button_2_id, button_2_text: button_2_text }));
        jQuery('.modal:not(.error)').modal();
    }

    handleDateTimeChange(event) {
        var prev = jQuery(".previous-date").val();
        var next = jQuery(".next-date").val();
        var timeframe = { prev: prev, next: next };
        var ids = this.props.business_id;
        if (timeframe.prev && timeframe.next) {
            // window.localStorage.setItem("timeframe", timeframe);
            window.localStorage.setItem("prev_date", timeframe.prev);
            window.localStorage.setItem("next_date", timeframe.next);
            this.props.dispatch(setCustomTimeframe(timeframe));
            if (this.props.region) {
                this.props.dispatch(
                    ajaxFeedbackStatusFilter(
                        this.props.state,
                        null,
                        "custom",
                        ids,
                        timeframe,
                        this.props.excludeStatistics
                    )
                );
            } else {
                if (this.props.doDispatch) {
                    this.props.dispatch(
                        ajaxFeedbackStatusFilter(
                            this.props.state,
                            null,
                            "custom",
                            timeframe,
                            null,
                            this.props.excludeStatistics
                        )
                    );
                }
            }
            // notify the parent timeframe changed
            // currently used in All Business Dashboard
            if (this.props.onTimeframeChange) {
                this.props.onTimeframeChange("custom");
            }
        }
    }

    handleChangeSendEmail(event) {
        this.setState({ ...this.state, send_email: event.target.value });
    }


    render() {
        return (
            <div className="col-xl-12">
                <div className="card card-mtd">
                    <Loading location={"stats"} />
                    <div className="title-row d-flex align-items-center">
                        <div className="card-title tab">
                            <div className="dropdown">
                                <button className="btn btn-card dropdown-toggle"
                                    type="button"
                                    id="dropdownMenuButton"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false">
                                    {this.props.timeframe === "monthToDate" ? __("Month to Date") : ""}
                                    {this.props.timeframe === "weekToDate" ? __("Week to Date") : ""}
                                    {this.props.timeframe === "today" ? __("Today") : ""}
                                    {this.props.timeframe === "yesterday" ? __("Yesterday") : ""}
                                    {this.props.timeframe === "lifetime" ? __("Lifetime") : ""}
                                    {this.props.timeframe === "last30" ? __("Last 30 Days") : ""}
                                    {this.props.timeframe === "custom" ? __("Custom Timeframe") : ""}
                                </button>
                                <div
                                    className="dropdown-menu"
                                    aria-labelledby="dropdownMenuButton"
                                >
                                    <a
                                        className="dropdown-item"
                                        onClick={this.handleClick.bind(this)}
                                        id="today"
                                        href="#"
                                    >
                                        {__('Today')}
                                    </a>
                                    <a
                                        className="dropdown-item"
                                        onClick={this.handleClick.bind(this)}
                                        id="yesterday"
                                        href="#"
                                    >
                                        {__('Yesterday')}
                                    </a>
                                    <a
                                        className="dropdown-item"
                                        onClick={this.handleClick.bind(this)}
                                        id="weekToDate"
                                        href="#"
                                    >
                                        {__('Week to Date')}
                                    </a>
                                    <a
                                        className="dropdown-item"
                                        onClick={this.handleClick.bind(this)}
                                        id="monthToDate"
                                        href="#"
                                    >
                                        {__('Month to Date')}
                                    </a>
                                    <a
                                        className="dropdown-item"
                                        onClick={this.handleClick.bind(this)}
                                        id="last30"
                                        href="#"
                                    >
                                        {__('Last 30 Days')}
                                    </a>
                                    <a
                                        className="dropdown-item"
                                        onClick={this.handleClick.bind(this)}
                                        id="lifetime"
                                        href="#"
                                    >
                                        {__('Lifetime')}
                                    </a>
                                    <a
                                        className="dropdown-item"
                                        onClick={this.handleClick.bind(this)}
                                        id="custom"
                                        href="#"
                                    >
                                        {__('Custom')}
                                    </a>
                                </div>
                            </div>
                        </div>

                        {this.props.timeframe == "custom" && (
                            <div className="card-title">
                                <input
                                    className="form-control previous-date"
                                    defaultValue={this.props.timeframe_prev}
                                    onChange={this.handleDateTimeChange.bind(
                                        this
                                    )}
                                    type="date"
                                    required
                                />
                            </div>
                        )}
                        {this.props.timeframe == "custom" && (
                            <div className="card-title">{__('To')}</div>
                        )}
                        {this.props.timeframe == "custom" && (
                            <div className="card-title">
                                <input
                                    className="form-control next-date"
                                    defaultValue={this.props.timeframe_next}
                                    onChange={this.handleDateTimeChange.bind(
                                        this
                                    )}
                                    type="date"
                                    required
                                />
                            </div>
                        )}

                        {/*{this.props.businesses && (*/}
                        {/*    <div className="card-title ml-auto">*/}
                        {/*        <a*/}
                        {/*            className="btn btn-outline-primary btn-sm text-primary"*/}
                        {/*            onClick={this.handleDownloadClick.bind(*/}
                        {/*                this*/}
                        {/*            )}*/}
                        {/*        >*/}
                        {/*            <i className="fas fa-file-download mr-1"></i>{" "}*/}
                        {/*            {__('Download Report PDF')}*/}
                        {/*        </a>*/}
                        {/*    </div>*/}
                        {/*)}*/}

                        {!this.props.hideExport &&
                            <div className="card-title ml-auto">
                                <a
                                    className="btn btn-outline-primary btn-sm text-primary"
                                    onClick={this.handleExportButtonClick.bind(this)}
                                    href="#"
                                >
                                    {__('Download XLS Export')}
                                </a>
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        state: state,
        current_user: state.current_user ?? null,
        business: state.business ?? null,
        timeframe: state.timeframe,
        businesses: state.businesses ?? null,
        timeframe_prev: state.timeframe_prev ?? null,
        timeframe_next: state.timeframe_next ?? null,
        department_ids: state.department_ids ?? null
    };
}

export default connect(mapStateToProps)(DashboardActionBar);
